export default "__VITE_ASSET__8a396eb6__"